<template>
  <c-view>
    <c-page class="coupon-container">
      <c-navbar title="领取成功"></c-navbar>
      <c-content>
        <div class="coupon-box">
          <div class="title">
            <div class="desc-title">518元旺铺券已放入您的账户中</div>
            <div class="desc-sub-title">礼金券有效期为2018.5.18~5.22</div>
            <div class="desc-remind">* 部分礼金券请至生意专家电脑端使用</div>
          </div>
          <c-images :img-items="images"></c-images>
        </div>
      </c-content>
      <c-footer class="bg-color gray" style="border-color: transparent;">
        <c-button style="background-color: #F5A623; border-color: transparent;" @click.native="goToCoupon">查看我的券
        </c-button>
      </c-footer>
    </c-page>
  </c-view>
</template>
<style lang="scss" scoped>
  @import './index.scss';
</style>
<script>
  import api from '@/tools/api-tools'

  export default {
    data () {
      return {
        images: [],
        config: {
          title: '生意专家双11预购',
          link: `http://wechat.i2oo.cn/static/stand-auth.html?presale1111`,
          imgUrl: 'http://oeeksk0b2.bkt.clouddn.com/syzj_20171111.png',
          description: '预购金可抵10倍现金，生意专家的优惠带着诚意扑面而来'
        }
      }
    },
    components: {},
    created () {
    },
    mounted () {
      this.getImages()
    },
    beforeDestroy () {
    },
    methods: {
      // 获取图片资源
      getImages () {
        return api.get(`http://cloud.fe.laoban100.com/cloud/5ae309f48a5639f5d6cae15a/hybrid/laoban/warmup`).then(res => {
          this.images = res.data.coupon
        })
      },
      // 跳转至礼券中心
      goToCoupon () {
        this.$router.replace('/aboutMe/ticketDetail')
      }
    },
    computed: {},
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?2c268b84